import { fetchWithClerkJwt } from "./fetch-with-clerk";

export type OpenSalesReceiptPdfResult =
  | { ok: true }
  | { ok: false; message: string };

export async function openSalesReceiptPdf(
  getToken: () => Promise<string | null>,
  stopId: string,
): Promise<OpenSalesReceiptPdfResult> {
  const res = await fetchWithClerkJwt(getToken, `/api/v1/stops/${encodeURIComponent(stopId)}/receipt.pdf`, {
    headers: { Accept: "application/pdf" },
  });
  if (res.status === 503) {
    return { ok: false, message: "Receipt downloads are not configured on the server yet." };
  }
  if (res.status === 404) {
    let code = "";
    try {
      const j = (await res.json()) as { error?: string };
      code = j.error ?? "";
    } catch {
      /* ignore */
    }
    if (code === "receipt_pdf_not_ready") {
      return { ok: false, message: "Receipt is not ready yet." };
    }
    return { ok: false, message: "Receipt is not available." };
  }
  if (res.status === 403) {
    return { ok: false, message: "You are not allowed to download this receipt." };
  }
  if (!res.ok) {
    return { ok: false, message: `Could not download receipt (HTTP ${res.status}).` };
  }
  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  window.open(objectUrl, "_blank", "noopener,noreferrer");
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 120_000);
  return { ok: true };
}
